import React from 'react';
import PropTypes from 'prop-types';

export default function AboutIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148050' />
      <path
        fill={fill}
        d='M10 2a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8m0-1a9 9 0 1 1-9 9 9 9 0 0 1 9-9Z'
        data-name='Elipse 439'
      />
      <path fill={fill} d='M9 15h2V9H9Zm0-8h2V5H9Z' />
    </svg>
  );
}

AboutIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

AboutIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
